



















































import { DashboardService, Erro } from "@/services/dashboard.service";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { dateTime } from "@/shared/filters";

@Component({
  filters: { dateTime }
})
export default class ErrosTabelaSuporte extends Vue {
  ListaErros: Erro[] | null = null;
  loadingErros = false;
  intervalId = 0;

  mounted() {
    this.carregarListaEventos();
  }

  async carregarListaEventos() {
    this.loadingErros = true;
    this.ListaErros = await DashboardService.ListaErros().finally(
      () => (this.loadingErros = false)
    );
  }
  
  beforeDestroy() {
    clearInterval(this.intervalId);
  }
}
